"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("./index");
function emoji(shortName, id, text) {
    return new Emoji({ shortName, id, text });
}
exports.emoji = emoji;
class Emoji extends index_1.InlineNode {
    constructor(attrs) {
        super();
        this.attrs = attrs;
    }
    toJSON() {
        const emojiNode = {
            type: 'emoji',
            attrs: {
                shortName: this.attrs.shortName
            }
        };
        if (this.attrs.id) {
            emojiNode.attrs.id = this.attrs.id;
        }
        if (this.attrs.text) {
            emojiNode.attrs.text = this.attrs.text;
        }
        return emojiNode;
    }
}
exports.Emoji = Emoji;
//# sourceMappingURL=emoji.js.map